import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';
import { signalrListen } from '@lib/signalr';
import type { UserDto } from '@/ApiClient';

// All users belonging to the current brand. Loaded once on app start and kept
// fresh via the `BrandUsersUpdate` SignalR event. Not built on `useGlobalStore`
// because that helper requires a numeric `id`, while users have a string id.
export const useBrandUsers = defineStore('brand-users', () => {
  const api = useApi();

  const loaded = ref<UserDto[]>([]);

  const loadAll = async () => {
    loaded.value = await api.users_ListBrandUsers(useUser().brandId);
  };

  const getById = (id: string): UserDto | undefined => loaded.value.find((user) => user.id === id);

  const listen = () => {
    signalrListen('BrandUsersUpdate', loadAll, { listenForever: true });
  };

  return { loaded, loadAll, listen, getById };
});
